import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import Step1 from './icons/Step1';
import Step2 from './icons/Step2';
import Step3 from './icons/Step3';
import Step4 from './icons/Step4';
// import Step5 from './icons/Step5';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterN: any = null,
    sceneTextLeaveN: any = null;
export default function N() {
    const { useLang, useRouter, useEffect, useState, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    const cards: any[] = [
        {
            icon: <Step1 />,
            step: t('secN_card1_step'),
            title: t('secN_card1_title'),
            desc: t.rich('secN_card1_desc', {
                n: (text: any) => <span className="no-wrap">{text}</span>,
            }),
        },
        {
            icon: <Step2 />,
            step: t('secN_card2_step'),
            title: t('secN_card2_title'),
            desc: t('secN_card2_desc'),
        },
        {
            icon: <Step3 />,
            step: t('secN_card3_step'),
            title: t('secN_card3_title'),
            desc: t('secN_card3_desc'),
        },
        {
            icon: <Step4 />,
            step: t('secN_card4_step'),
            title: t('secN_card4_title'),
            desc: t('secN_card4_desc'),
        },
    ];

    // if (locale === 'us') {
    //     cards.push({
    //         icon: <Step5 />,
    //         step: t('secN_card5_step'),
    //         title: t('secN_card5_title'),
    //         desc: t('secN_card5_desc'),
    //     });
    // }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterN) {
                    AniContainer.removeScene(sceneTextEnterN);
                    sceneTextEnterN = null;
                }
                if (sceneTextLeaveN) {
                    AniContainer.removeScene(sceneTextLeaveN);
                    sceneTextLeaveN = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterN = AniContainer.create({
                    triggerElement: '.shp2-detail-N .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterN) {
                    AniContainer.removeScene(sceneTextEnterN);
                    sceneTextEnterN = null;
                }
                if (sceneTextLeaveN) {
                    AniContainer.removeScene(sceneTextLeaveN);
                    sceneTextLeaveN = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`shp2-detail-N shp2-detail-section ${css['shp2-detail-N']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h4 className="subtitle">
                    {t.rich('secN_subtitle', {
                        t: (text: any) => <span className="through">{text}</span>,
                    })}
                </h4>
                <h2 className="title">{t('secN_title')}</h2>
                <p className="desc">
                    {t.rich('secN_desc', {
                        w: (text: string) => <span className="white">{text}</span>,
                    })}
                </p>
            </div>
            <div className="cards">
                <ul className="steps">
                    {cards?.map((card: any, k: number) => (
                        <li className="step" key={k}>
                            <span className="step-icon">{card?.icon}</span>
                            <div className="card-info">
                                <p className="card-title">
                                    {card?.step} {card?.title}
                                </p>
                                <p className="card-desc">{card?.desc}</p>
                            </div>
                        </li>
                    ))}
                </ul>
                <div className="card-img">
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1754042725317/740X%20600.png"
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1754031157668/1500%E2%80%8A%C3%97%E2%80%8A720.jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1754031157668/1500%E2%80%8A%C3%97%E2%80%8A720.jpg"
                        alt={t('secU_title')}
                    />
                </div>
            </div>
            {locale === 'us' && (
                <Link
                    className="link"
                    href={`https://us.ecoflow.com/products/smart-home-panel-2-installation-consulting-service?variant=40768226525257`}
                    target="_blank"
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'service_button',
                        position: t('secN_title'),
                        button_name: t('secN_link'),
                    }}
                >
                    <span className="link-text">{t('secN_link')}</span>
                    <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M6.25651 2.3584L11.5898 7.69173L6.25651 13.0251"
                            stroke="#3F68E0"
                            strokeWidth="1.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </Link>
            )}
        </section>
    );
}
